module.exports = __webpack_public_path__ + "media/images/tutorial_header_sp1-03-535decd78ae4874017977e825dc41562.png";